const calculateTax2024to2025 = (incomeIn) => {
  let income = Number(incomeIn);
  let tax = 0;

  // https://www.ato.gov.au/tax-rates-and-codes/tax-rates-australian-residents?=redirected_calc_incometaxrates#ato-Australianresidenttaxrates2020to2025
  if (income <= 18200) {
    tax = 0; // Tax-free threshold
  } else if (income <= 45000) {
    tax = (income - 18200) * 0.16;
  } else if (income <= 135000) {
    tax = 4288 + (income - 45000) * 0.3;
  } else if (income <= 190000) {
    tax = 31288 + (income - 135000) * 0.37;
  } else {
    tax = 51638 + (income - 190000) * 0.45;
  }
  return tax;
};

const CalculateNetIncome = (incomeIn) => {
  let income = Number(incomeIn);
  let tax = calculateTax2024to2025(income);

  return income - tax - income * 0.02; // 0.02 come from spreadsheet
};

export default CalculateNetIncome;
